import Service from '@/services/modules/teams.service';

const add = async({ commit }, _object) => {
    const response = Service.add(_object);

    response.then(function (_response) {
        commit('add', _response);
    });

    return response;
};

const all = async ({ commit }, branch_id) => {
    const response = Service.get(undefined, branch_id);

    response.then(function (_response) {
        commit('setList', _response);
    });

    return response;
};

const edit = async({ commit }, _object) => {
    const response = Service.edit(_object.id, _object);

    return response;
};

const get = async ({ commit }, _id) => {
    const response = Service.get(_id);

    response.then(function (_response) {
        commit('setObject', _response);
    });

    return response;
};


const rem = async({ commit }, _object) => {
    const response = Service.rem(_object.id);

    return response;
};

export default {
    add,
    all,
    edit,
    get,
    rem
};